import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import headbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import './boiteIdee.scss'
export default function BoiteIdee() {
   const { setHeadband } = useContext(headbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   const { setCounter, counterDefault } = useContext(CounterContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('Suggestion System')
      setAnchorButton([])
   }, [])
   return (
      <div>
         <iframe
            style={{ left: 50, top: 50 }}
            width='980'
            height='1050'
            src='https://forms.office.com/Pages/ResponsePage.aspx?id=PkrXX3rVDkGNfALE3wYiNJAyk6qHwYRIoIcAaXk1ifxUQ1RaVVBQSjRITzBQWUxaNExSRlRVT0VFRi4u'
         ></iframe>
      </div>
   )
}
